import React, { useState } from 'react';
import { Box, Button, Typography, Modal, Backdrop, Fade, Snackbar, Alert } from '@mui/material';
import { AiOutlineShareAlt, AiOutlineLink } from 'react-icons/ai';
import PropTypes from 'prop-types';
import styles from './SharePageButton.module.css';

const SharePageButton = ({ withBackground = false, title = '', customUrl = '' }) => {
  const [open, setOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const url = customUrl || window.location.href;
  const shareTitle = title || document.title || "Check this out!";

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleShareOption = (platform) => {
    let shareUrl = '';

    if (platform === 'Twitter') {
      shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(shareTitle)}`;
    } else if (platform === 'Facebook') {
      shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    }

    window.open(shareUrl, '_blank');
    handleClose();
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
    handleClose();
  };

  const handleSnackbarClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  return (
    <Box>
      <Button 
        className={`${styles.moreButton} ${withBackground ? styles.withBackground : ''}`} 
        onClick={handleOpen}
      >
        <AiOutlineShareAlt className={styles.moreIcon} />
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={open}>
          <Box className={styles.modalContent}>
            <Typography className={styles.modalTitle}>Share this page</Typography>

            <Box className={styles.option} onClick={() => handleShareOption('Twitter')}>
              <img src="/twitter.svg" alt="Twitter" className={styles.icon} />
              <Typography>Share on Twitter</Typography>
            </Box>

            <Box className={styles.option} onClick={() => handleShareOption('Facebook')}>
              <img src="/facebook.svg" alt="Facebook" className={styles.icon} />
              <Typography>Share on Facebook</Typography>
            </Box>

            <Box className={styles.option} onClick={handleCopyLink}>
              <AiOutlineLink className={styles.icon} />
              <Typography>Copy Page URL</Typography>
            </Box>

            <Button className={styles.closeButton} onClick={handleClose}>Close</Button>
          </Box>
        </Fade>
      </Modal>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="success" onClose={handleSnackbarClose}>
          Link copied to clipboard!
        </Alert>
      </Snackbar>
    </Box>
  );
};

SharePageButton.propTypes = {
  withBackground: PropTypes.bool,
  title: PropTypes.string,
  customUrl: PropTypes.string,
};

export default SharePageButton;